/* Adapt PDP "diagnosis" section (2026-10-05). Strike-through lineup + eye diagram steps + burn clock all trigger when scrolled into view. Loaded with defer by sections/pdp-value-strip.liquid. */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-dx]').forEach(function(root){
    root.classList.add('has-js');

    function onView(el, cb, th){
      if(!('IntersectionObserver' in window)){ cb(); return; }
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if(e.isIntersecting){ io.disconnect(); cb(); }
        });
      }, { threshold: th || 0.3 });
      io.observe(el);
    }

    var sus = root.querySelector('[data-dx-sus]');
    var clock = root.querySelector('[data-dx-clock]');
    if(sus) onView(sus, function(){ sus.classList.add('is-in'); }, 0.35);
    if(clock) onView(clock, function(){ clock.classList.add('is-in'); }, 0.4);
    setTimeout(function(){
      if(sus) sus.classList.add('is-in');
      if(clock) clock.classList.add('is-in');
    }, 8000);

    var mech = root.querySelector('[data-dx-mech]');
    if(!mech) return;
    var svg = mech.querySelector('[data-dx-svg]');
    var steps = Array.prototype.slice.call(mech.querySelectorAll('[data-dx-step]'));
    var timer = null, userTook = false;

    function setStep(n){
      if(svg) svg.setAttribute('data-step', String(n));
      steps.forEach(function(s, i){
        var on = (i + 1) === n;
        s.classList.toggle('is-on', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    steps.forEach(function(s, i){
      s.addEventListener('click', function(){
        userTook = true;
        clearTimeout(timer);
        setStep(i + 1);
      });
    });
    setStep(1);

    if(!reduce){
      onView(mech, function(){
        var n = 1;
        (function next(){
          timer = setTimeout(function(){
            if(userTook) return;
            n++;
            if(n <= steps.length){ setStep(n); next(); }
          }, 2600);
        })();
      }, 0.4);
    }
  });
})();